<template>
  <div class="panel-box">
    <div class="panel-title">{{title}}</div>
    <template v-if="!hidden_desc">
      <div class="desc">提示</div>
      <div class="desc" v-for="(item, index) in desc" :key="index">{{item}}</div>
    </template>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    props: {
      title: null,
      hidden_desc: {
        type: Boolean,
        default: false
      },
      desc: {
        type: null,
        default: () => ([])
      }
    }
  }
</script>

<style lang="less" scoped>
  .panel-box {
    .bg(#fff);
    .mb(.24rem);
    .br(.1rem);
    .p(.3rem .3rem 0);
    .panel-title {
      display: flex;
      align-items: center;
      .fz(.34rem);
      font-weight: bold;
      .mb(.36rem);
      .c(#333);
      &::before {
        content: '';
        .w(.08rem);
        .h(.24rem);
        .br(.04rem);
        .bg(#00b0f4);
        .mr(.09rem);
      }
    }
    .desc {
      .fz(.24rem);
      .c(#999);
      .lh(1.8);
    }
  }
</style>
